import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  changeHandler() {
    const value = this.inputTarget.value
    const cleanedValue = value.replace(/-/g, '')
    this.inputTarget.value = cleanedValue
  }
}
